import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function Footer() {
  return (
    <footer className="border-t border-background-200/60 bg-background-100/80">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2" aria-label="韩国妖精漫画首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-sparkling-2-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-primary-400">妖精漫画</span>
            </Link>
            <p className="mt-4 text-sm leading-6 text-foreground-600">
              聚合韩国妖精漫画奇幻、魔法、异世界、精灵、妖怪、神话等热门题材，为你提供世界观设定与最新话追更入口。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-950">热门分类</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-950">快速入口</h3>
            <ul className="mt-4 space-y-2">
              <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-500">首页</Link></li>
              <li><Link to="/category/isekai" className="text-sm text-foreground-600 hover:text-primary-500">异世界追更</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500">关于我们</Link></li>
              <li><Link to="/about#contact" className="text-sm text-foreground-600 hover:text-primary-500">联系我们</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-foreground-950">追更提示</h3>
            <p className="mt-4 text-sm leading-6 text-foreground-600">
              每日更新最新话情报与热门作品榜单，支持正版连载，一起守护创作者的心血。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-background-200/60 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">© 2026 妖精漫画 · 韩国妖精漫画奇幻异世界大全</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500">免责声明</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500" aria-label="分享">
              <i className="ri-share-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}